module.exports = __webpack_public_path__ + "img/Maradona-5.28444316.webp";